module.exports = __webpack_public_path__ + "abd49bfd0cfea89ff79074cc780d75aa.png";